module.exports = function () {
	window.searchFilters = {};
	window.searchFilters['facetIds'] = [];
	Innophos.Pages.ProductSearchPage.PaginationEvents();
	Innophos.Pages.ProductSearchPage.CartEvents();
	Innophos.Pages.ProductSearchPage.FilterEvents();

	Innophos.Pages.ProductSearchPage.SetRequestBarPosition();
};
